import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'users',
  initialState: {
    items: {},
    selectedId: null
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach(item => state.items[item['id']] = item);
    },
    update(state, action) {
      state.items = {};
      action.payload.forEach(item => state.items[item['id']] = item);
    }
  }
});

export { actions as usersActions };
export { reducer as usersReducer };
